import { IAuth } from "../auth/auth";
import { Axios } from "../axios";

export const getTransactionCommissions = async (
  body: IAuth.IHistoryTrxnPageProps
) => {
  const { page, size, ascending, filter, fromDate, toDate } = body;
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(
      `/remit/user/${currentUser.vendor_key}/commissiontransactions`,
      {
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
        params: {
          pageNumber: page,
          pageSize: size,
          ascending: ascending,
          filter: filter,
          fromDate: fromDate,
          toDate: toDate,
        },
      }
    );
  }
};

export const downloadTransactionCommission = async (
  currentUser: IAuth.IIsAuthorisedProps,
  fromDate: string,
  toDate: string
) => {
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(
      `/remit/user/${currentUser.vendor_key}/commissiontransactions/download`,
      {
        responseType: "blob",
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
        params: {
          fromDate: fromDate,
          toDate: toDate,
        },
      }
    );
  }
};